'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('AtividadesService', function($http) {
  return {
    list: function(listComEmpreendimento) {
      const params = { no_paginate: true };

      if (listComEmpreendimento) {
        params.somente_com_empreendimento = true;
      }

      return $http.get(`${SERVER}${API_VERSION}atividades`, params);
    },

    listComEmpreendimento: function() {
      return this.list(true);
    },

    getProdutividadeUnidade(atividade) {
      if (this.isAlgodao(atividade)) {
        return '@';
      }

      if (this.isCana(atividade)) {
        return 'ton';
      }

      return 'sc';
    },

    isWheat: function(atividade) {
      return (atividade || '').toUpperCase().includes('TRIGO');
    },

    isCorn: function(atividade) {
      return (atividade || '').toUpperCase().includes('MILHO');
    },

    isCevada: function(atividade) {
      return (atividade || '').toUpperCase().includes('CEVADA');
    },

    isTriticale: function(atividade) {
      return (atividade || '').toUpperCase().includes('TRITICALE');
    },

    isAveiaPreta: function(atividade) {
      return (atividade || '').toUpperCase().includes('AVEIA') && (atividade || '').toUpperCase().includes('PRETA');
    },

    isAveiaBranca: function(atividade) {
      return (atividade || '').toUpperCase().includes('AVEIA') && (atividade || '').toUpperCase().includes('BRANCA');
    },

    isErvilhaca: function(atividade) {
      return (atividade || '').toUpperCase().includes('ERVILHACA');
    },

    isProdutividadeLikeWheat(atividade) {
      return this.isWheat(atividade) || this.isCevada(atividade) || this.isTriticale(atividade) ||
      this.isAveiaBranca(atividade) || this.isAveiaPreta(atividade) || this.isErvilhaca(atividade);
    },

    isAlgodao(atividade) {
      return (atividade || '').toUpperCase().includes('ALG');
    },

    isCana(atividade) {
      return (atividade || '').toUpperCase().includes('CANA');
    }
  };
});
